<template>
    <div>
        <custom-tooltip-container :open-by-default="true">
            <template #tooltipTarget>
                <div class="ob1-link-icon ps-1" data-testid="cart-recovery-tooltip-target">
                    <span
                        class="icon"
                        :class="icon"
                        style="font-size: 40px"
                        aria-hidden="true"
                    />
                    <span
                        v-if="showBadge"
                        class="ob1-badge ob1-badge-negative ob1-badge-large"
                        style="margin-left: -10px;margin-top: -40px;"
                        v-text="badgeValue"
                    />
                    <span v-if="showBadge" class="visually-hidden">articles dans votre panier</span>
                </div>
            </template>
            <template #tooltipContent>
                <div data-testid="cart-recovery-tooltip-content">
                    <div class="d-flex flex-column p-1">
                        <strong class="mb-2 font-size-16" v-text="tooltip.title" />
                        <span
                            v-for="(item, idx) in tooltipContentList"
                            :key="idx"
                            class="mb-1 d-block"
                        >
                            {{ item.trim() }}
                        </span>
                        <div class="text-center">
                            <generic-button-cta :dto-from-object="tooltip.cta" :css-classes="'btn-primary px-1 px-md-2 mt-1 mt-lg-0'" />
                        </div>
                    </div>
                </div>
            </template>
        </custom-tooltip-container>
    </div>
</template>

<script>

import GenericButtonCta from "../../../../../common/broadband/components/GenericButtonCta.vue";
import CustomTooltipContainer from "../../../../../common/components/vue/tooltip/CustomTooltipContainer.vue";

export default {
    name: "CartRecovery",
    components: {
        CustomTooltipContainer,
        GenericButtonCta
    },
    props: {
        icon: { type: String, required: true },
        showBadge: { type: Boolean, default: false },
        badgeValue: { type: Number, default: 0 },
        tooltip: { type: Object, default: undefined }
    },
    data() {
        return {
        }
    },
    computed: {
        tooltipContentList() {
            return this.tooltip?.content || [];
        }
    }
}
</script>

<style scoped lang="scss">
.ob1-link-icon .icon::before {
    font-size: inherit;
}
</style>
